<template>
  <div data-cy="requestPaymentOptions">
    <h5 class="mt-2 mb-3 payment-title">
      {{ paymentText }}
    </h5>
    <span class="text-payment-sub">
      {{ textOfPaymentType }}
    </span>
    <SelectTradeButtonsMaterial :options="options" @value="storeRequestPaymentType" :savedOption="saved"
      data-cy="pay-with" :isTradeOption="true" />
    <span v-if="haveFunds === false" class="insuficient-funds">You don't have enough points</span>
    <LoadingSpinner position="absolute" v-if="isFetching" />
  </div>
</template>

<script>
import SelectTradeButtonsMaterial from "@/material-components/atoms/SelectTradeButtonsMaterial";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import itemType from "@/enum/item-type";
import PointsHelperVue from "../../mixins/PointsHelper.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";

export default {
  name: "RequestPaymentType",
  mixins: [ItemHelperVue, PointsHelperVue],
  props: ["item", "choice"],
  components: {
    SelectTradeButtonsMaterial,
    LoadingSpinner
  },
  data() {
    return {
      options: this.getOptions(),
      option: null,
      haveFunds: null,
      isFetching: false,
    };
  },
  computed: {
    saved() {
      if (this.option) {
        return this.option;
      }
      return null;
    },
    paymentText() {
      if (this.item.points === 0 && this.item.cash === 0) {
        return "This item is free!"
      }
      if (
        this.item.type === itemType.RECEIVE ||
        this.item.type === itemType.BORROW
      ) {
        return "How do you want to get paid?";
      } else if (
        this.item.type === itemType.GIVE ||
        this.item.type === itemType.LEND
      ) {
        return "How do you want to pay?";
      }
      return null;
    },
    textOfPaymentType() {
      if (this.getPaymentType() == "points and cash") {
        return "Choose your preferred method available to pay.";
      } else return "This item has only one method available to pay.";
    }
  },
  methods: {
    getPaymentType() {
      if (this.item.points > 0 && this.item.cash > 0) return "points and cash";
      if (this.item.points > 0 && this.item.cash === 0) return "points";
      if (this.item.cash > 0 && this.item.points === 0) return "cash";
      if (this.item.cash === 0 && this.item.points === 0) return "free"
    },
    getOptions() {
      switch (this.getPaymentType()) {
        case "points and cash":
          return [
            {
              option: this.cashPrice(),
              value: "money",
              isSelected: false,
              tooltip: false,
            },
            {
              option: this.pointsPrice(),
              value: "points",
              isSelected: false,
              tooltip: false,
              iconClass: "material-icons",
              tradeIcon: "hexagon"
            },
          ];
        case "points":
          return [
            {
              option: this.pointsPrice(),
              value: "points",
              isSelected: false,
              tooltip: false,
              iconClass: "material-icons",
              tradeIcon: "hexagon"
            },
          ];
        case "cash":
          return [
            {
              option: this.cashPrice(),
              value: "money",
              isSelected: false,
              tooltip: false,
            },
          ];
        case "free":
          return [
            {
              option: "$0",
              value: "money",
              isFree: true,
              isSelected: false,
              tooltip: false,
              isRemovable: false,
            },
          ];
      }
    },
    storeRequestPaymentType(e) {
      if (e) {
        this.option = e;
        if (this.option === "points") this.checkPoints();
        else this.haveFunds = null;

        if (this.haveFunds === false) this.$emit("insuficentFunds");
        else this.$emit("chosenPayment", this.option);
      }
    },
    pointsPrice() {
      return `${this.item.points}`;
    },
    cashPrice() {
      return `$${this.item.cash}`;
    },
    checkPoints() {
      if (
        this.item.type === itemType.GIVE ||
        this.item.type === itemType.LEND
      ) {
        this.haveFunds = this.checkFunds(this.item.points);
      } else {
        this.haveFunds = null;
      }
    }
  },
  mounted() {
    this.isFetching = true;
    if (this.choice) {
      this.option = this.choice;
      this.options.forEach((element) => {
        if (this.option.includes(element.value)) {
          element.isSelected = true;
        }
      });
    }
    setTimeout(() => {
      this.isFetching = false;
    }, 2000);
  },
};
</script>

<style lang="scss" scoped>
.payment-title,
.text-payment-sub {
  display: flex;
  justify-content: flex-start;
  line-height: 20px;
  letter-spacing: 1.25px;
  font-weight: normal;
}

.payment-title {
  color: $black;
  font-size: 20px;
}

.text-payment-sub {
  color: $black-sub-color;
  margin-bottom: 2.2rem;
}

.insuficient-funds {
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1.25px;
  color: $danger;
}
</style>
